import { Controller } from "@hotwired/stimulus"

const POLL_MS = 2500

export default class extends Controller {
  static values = { url: String, status: String }

  connect() {
    if (this.statusValue === "pending") {
      this.timer = setTimeout(() => this.poll(), POLL_MS)
    }
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "text/vnd.turbo-stream.html" },
        credentials: "same-origin"
      })
      if (response.ok) {
        const stream = await response.text()
        Turbo.renderStreamMessage(stream)
      }
    } catch (e) {
      // Network blip — keep polling, the next tick will retry.
    }
  }
}
